import * as yup from 'yup';

import { isValidURL } from '../../validation';

const validationSchemaGeneral = yup
  .object({
    name: yup.string().required(),
    address: yup.string().required(),
    website: yup
      .string()
      .nullable()
      .test({
        name: 'is-valid-url-with-prefix',
        test: (value, testContext) => {
          if (value === undefined || value === null) {
            return true;
          }

          if (isValidURL(value) && (value.startsWith('http://') || value.startsWith('https://'))) {
            return true;
          }

          return testContext.createError({
            path: 'website',
            message: {
              id: 'venue-data-collection.venue-information-form.invalid-venue-url',
              values: { invalidUrl: value },
            },
          });
        },
      }),
    postCode: yup.string().required(),
    city: yup.string().required(),
    country: yup.string().required(),
  })
  .required();

export type ValidDraftVenueGeneralFormValues = yup.InferType<typeof validationSchemaGeneral>;

export default validationSchemaGeneral;
